import { NgRedux, select } from '@angular-redux/store';
import { Component } from '@angular/core';
import { AppState } from '../../../store/state.model';
import { OrchestrationService } from '../../services/orchestration-service/orchestration.service';
import { SidenavService } from '../../services/sidenav.service';
import { regex } from '../../../common/regex.constants';
import { Observable, Subscription } from 'rxjs';
import { ApiResponseActions } from '../../../store/api-response/api-response-actions';
import { ApiResponseState } from '../../../store/api-response/api-response-state.model';
import { AdminApiHandlerService } from '../../services/api-handler/api-handler.service';
import { environment } from '../../../../environments/environment';
import { SpinnerService } from '../../../common/components/spinner/overlay-spinner.service';
import { SnackBarService } from '../../../common/services/snack-bar/snack-bar.service';
import { TranslationService } from '../../../common/services/languages/translation.service';
import { AdminState } from '../../../store/admin-store/admin-state.model';
import { MatButton } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { NgIf, NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-update-remote-user',
    templateUrl: './update-remote-user.component.html',
    styleUrls: ['./update-remote-user.component.scss'],
    imports: [MatButton, FormsModule, MatFormField, MatLabel, MatInput, NgIf, NgClass, TranslatePipe]
})
export class UpdateRemoteUserComponent {
  /**
  *@property stores the boolean value to enable/disable the enableMatchWithPrimaryBtn button or not
  **/
  public enableMatchWithPrimaryBtn = false;
  /**
  *@property store the selected vehicle details
  **/
  public selectedVehicleDetails: any;
  /**
  *@property stores the value of the selected subscriber guid
  **/
  public selectedSubscriberGuid: any;
  /**
  *@property stores the boolean value to enable/disable the email pattern error
  **/
  public emailPatternError = false;
  /**
  *@property stores the boolean value to enable/disable the confirm button
  **/
  public enableConfirmBtn = false;
  /**
  *@property stores the entered input value
  **/
  public enteredValue: any;
  /**
  *@arg  observe api variable in redux
  **/
  @select('api') readonly apiObservable: Observable<ApiResponseState>;
  /**
  *@arg  observe api variable in redux
  **/
  @select('admin') readonly adminObservable1: Observable<AdminState>;
  /**
   * @property used to store the  subscription
   */
  public subscription: Subscription;
  /**
  *@property stores the boolean value whether the customer found or not
  **/
  public customerNotFound: boolean;
  /**
  *@property stores the selected VIN
  **/
  public selectedVin: string;

  constructor(
    private sidenav: SidenavService,
    private reduxState: NgRedux<AppState>,
    public orch: OrchestrationService,
    public apiHandler: AdminApiHandlerService,
    public spinner: SpinnerService,
    private snackBarService: SnackBarService,
    public translate: TranslationService,
  ) {
    this.apiObservable.subscribe((api) => {
      if (api.apiAction === ApiResponseActions.SET_UPDATE_REMOTE_USER) {
        if (api.apiResponse['type'] === 'success') {
          this.snackBarService.showToast(this.translate.getCustomTranslation('update-remote-user.labels.success')['value']);
          this.orch.getVehicleByVin({ vin: this.selectedVin.toUpperCase() });
          this.close();
        } else {
          this.snackBarService.showToast(this.translate.getCustomTranslation('errors.error-ocurred')['value']);
          this.close();
        }
      }
    });
    this.adminObservable1.subscribe((adminStore) => {
      this.selectedVin = adminStore['updateValue'];
      this.selectedVehicleDetails = this.reduxState.getState().selectedVehicle['vehicle'];
      if (this.selectedVehicleDetails['remoteUserGuid'] != this.selectedVehicleDetails['subscriberGuid']) {
        this.enableMatchWithPrimaryBtn = true;
      }
    }
    );
  }

  /**
  * @function close closes the side nav when called and restore the default values
  **/
  public close(): void {
    this.sidenav.close();
    this.enteredValue = '';
    this.enableConfirmBtn = false;
    this.enableMatchWithPrimaryBtn = false;
    this.emailPatternError = false;
    this.customerNotFound = false;
  }

  /**
  * @function updateRemoteUser hits the update remote user end point
  **/
  public updateRemoteUser(): void {
    const data = {
      vin: this.selectedVin,
      subscriberGuid: this.selectedVehicleDetails['subscriberGuid'],
      remoteUserGuid: this.selectedSubscriberGuid
    };
    const params = {
      brand: this.selectedVehicleDetails['brand']
    };
    this.orch.updateRemoteUser(data, params);
  }

  /**
  * @function matchWithPrimary calls the update remote user end point to match the remote guid with primary guid
  **/
  public matchWithPrimary(): void {
    this.selectedSubscriberGuid = this.selectedVehicleDetails['subscriberGuid'];
    this.updateRemoteUser();
  }

  /**
  * @function getCustomerGuid gets the customer details of the entered email
  **/
  public getCustomerGuid(): void {
    const params = { email: this.enteredValue, mode: 'read' };
    const spinnerRef = this.spinner.open();
    this.apiHandler.getRequest(environment.admin.apis.customer_search, { type: 'acm-dealer', params }).subscribe({
      next: (response) => this.onCustomerSuccess(response, spinnerRef),
      error: (error) => this.onCustomerFailed(spinnerRef)
    }
    );
  }

  /**
  * @function onCustomerSuccess gets the guid of the customer and call the update remote user end point
  **/
  public onCustomerSuccess(response, spinnerRef): void {
    spinnerRef.close();
    this.selectedSubscriberGuid = response['payload']['customer']['guid'];
    this.updateRemoteUser();
  }

  /**
  * @function onCustomerFailed shows the customer not found error
  **/
  public onCustomerFailed(spinnerRef): void {
    spinnerRef.close();
    this.customerNotFound = true;
  }

  /**
  * @function onConfirm checks for the validations for email/guid, if email entered it will fetch the guid and call the update remote user
  * end point
  **/
  public onConfirm(): void {
    this.emailPatternError = false;
    this.customerNotFound = false;
    if (regex.emailPattern.test(this.enteredValue) || regex.guidPattern.test(this.enteredValue)) {
      if (regex.emailPattern.test(this.enteredValue)) {
        this.getCustomerGuid();
      } else if (regex.guidPattern.test(this.enteredValue)) {
        this.selectedSubscriberGuid = this.enteredValue;
        this.updateRemoteUser();
      }
    } else {
      this.emailPatternError = true;
    }
  }

  /**
  * @function onKeyUp method triggers when key up event is performed on the input element
  **/
  public onKeyUp(): void {
    this.emailPatternError = false;
    this.customerNotFound = false;
  }
}
